import { useLayoutEffect } from "react";

/** Reports `dirty` to `onDirtyChange`, and false on unmount, so a dialog's "Discard
 *  changes?" guard never outlives the form that set it (NG-2823, NG-2924).
 *
 *  Must stay a layout effect: the dialog reads `unsavedChanges` from its last commit,
 *  and a passive effect defers the parent update past the keystroke's event, so a click
 *  outside landing in between closed the window unguarded. */
export function useReportUnsavedEdits(
  dirty: boolean,
  onDirtyChange: ((dirty: boolean) => void) | undefined,
): void {
  useLayoutEffect(() => {
    onDirtyChange?.(dirty);
    return () => onDirtyChange?.(false);
  }, [dirty, onDirtyChange]);
}
